/**
 * Helper for Data-defined Events (i.e. those in stores/event_data), NOT event_emitter
 * @module
 */

var _ = require('optimizely-client-fn');

/**
 * @param  {string} id
 * @param  {string} apiName
 * @param  {string} eventType
 * @param  {Object} [options]
 * @returns {EventSchema}
 */
exports.create = function(id:string, apiName:string, eventType:string, options?:any): EventSchema {
  var customEvent = _.extend({
    category: 'other',
  }, options, {
    id: id,
    apiName: apiName,
    eventType: eventType,
  });

  if (__INVARIANT__) {
    require('../utils/invariant').isType('Event', customEvent);
  }

  return customEvent;
};
